import React from 'react';

const checkboxField = (
  { input: { value, ...restInput }, label, inline=false, meta: { touched, invalid, error }, autofocus = false, id, help = null, checkbox, ...custom },
) => (
    <div>NOT IMPLEMENTED</div>
);

export default checkboxField;
